import { faIcon } from "@utils/faIcon"

import { Avatar, Badge } from "@atoms"

import ObjectCard from "@molecules/ObjectCard/ObjectCard"

import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"

// Object types whose cards carry a body avatar, so their skeleton includes the avatar placeholder. Pricebook
// items are mixed (only products have one), so they use the avatar-less skeleton.
const OBJECT_TYPES_WITH_AVATAR: ObjectType[] = [
    "bill",
    "client",
    "credit_note",
    "purchase_order",
    "vendor",
    "vendor_credit",
]

// Both are replaced by skeletons while loading, but the slots require a node.
const loadingAvatarIcon = faIcon({ name: "building", style: "solid" })
const loadingStatusBadge = <Badge size="md" isLoading={true} />

// One object card in its loading state, shaped like the active object type's card.
export default function CardsViewSkeletonCard() {
    const { objectType } = useObjectsView()

    const hasAvatar = OBJECT_TYPES_WITH_AVATAR.includes(objectType)

    return (
        <ObjectCard isLoading={true}>
            <ObjectCard.Header statusBadge={loadingStatusBadge} />
            <ObjectCard.Body
                avatar={hasAvatar ? <Avatar variant="object" icon={loadingAvatarIcon} size="xl" /> : undefined}
                primaryText=""
            />
            <ObjectCard.Attributes>{null}</ObjectCard.Attributes>
        </ObjectCard>
    )
}
